/**
 * Insights Components - Context-switching insight widgets for Copilot panel
 *
 * Each component provides entity-specific AI insights:
 * - ProjectSynthesis: LLM-generated project health summary
 * - RFQQuoteAnalysis: Vendor quote comparison and recommendation
 * - ProductSourcingIntel: Product pricing and availability
 * - VendorPerformance: Vendor metrics and activity
 * - DiscoverySynthesis: Discovery search AI synthesis
 *
 * @layer presentation
 * @arch_domain copilot
 */

export { ProjectSynthesis } from './project-synthesis';
export { RFQQuoteAnalysis } from './rfq-quote-analysis';
export { ProductSourcingIntel } from './product-sourcing-intel';
export { VendorPerformance } from './vendor-performance';
export { QualityPanel } from './quality-panel';
export { DiscoverySynthesis } from './discovery-synthesis';
